import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { media } from '~src/styles/media-templates';

export const footerLinkStyles = css`
  padding: 0 5px;
  font-size: 10px;
  text-decoration: none;
  &,
  &:hover {
    color: ${({ theme }) => theme.white.a9};
  }
  &:hover {
    text-decoration: underline;
  }
`;

export const StyledFooterLink = styled.a`
  ${footerLinkStyles}
`;

export const FooterLink = styled(Link)`
  ${footerLinkStyles}
`;

export const ContactLink = styled.div`
  > span {
    ${media.phone`
      display: none;
    `};
  }
`;

export const StyledFooter = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  background-color: ${({ theme }) => theme.baseBlue.a10};
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  color: ${({ theme }) => theme.white.a9};
  font-size: 10px;
  ${media.phone`
    height: 35px;
    font-size: 10px;
    flex-direction: column;
  `};

  &.new-footer {
    color: ${({ theme }) => theme.baseBlue.a6};
    background-color: ${({ theme }) => theme.white.a10};
    ${StyledFooterLink}, ${FooterLink} {
      &,
      &:hover {
        color: ${({ theme }) => theme.baseBlue.a6};
      }
    }
  }
`;
